export default {
  direction: 'rtl',

  home: {
    header: {
      selectLanguage: 'زبان',
      contact: 'Contact',
      blog: 'Blog',
      atrvasa: 'Atrvasa'
    },
    main: {
      index:{
        bannerTitle: 'راه حلی برای محصولات نرم افزاری',
        bannerDescription: 'برای ایجاد و نگهداری محصولات خود از یک روش آسان استفاده کنید.',
        bannerFooter: 'این کارها را با آترواسا انجام دهید:'
      },
      contact: {
        bannerTitle: 'آترواسا (امین نوری)',
        bannerDescription: '',
        sendRequestName: 'نام',
        sendRequestPhone: 'تلفن',
        sendRequestEmail: 'ایمیل',
        sendRequestDesc: 'شرح',
        sendRequestTitle: 'بفرست'
      }
    },
    footer: {
      dashboard: 'داشبورد',
      links: 'پیوندها',
      github: 'GitHub'
    }
  },

  dashboard:{
    logoutTitle: 'خروج'
  },

  el: {
    colorpicker: {
      confirm: 'تایید',
      clear: 'پاک کن'
    },
    datepicker: {
      now: 'Now',
      today: 'امروز',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select',
      noData: 'No data'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      buttonTitle: 'فایل مورد نظر را انتخاب کنید',
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue',
      note: 'فایل های jpg/png با ظرفیت کمتر از 500 کیلو بایت'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    },
    image: {
      error: 'FAILED'
    },
    pageHeader: {
      backButtonText: 'بازگشت' // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }
  },

  notify: {
    exceptionTitle: 'خطا',
    warningTitle: 'اخطار'
  },

  taskList: {
    startTimeCaption: 'زمان ورود',
    loadedCaption: 'Incoming Time'
  },
  listStructure: {
    importDialogTitle: 'وارد کردن مدل ها از فایل json',
    importButton: 'وارد کن',
    selectFileForImport: 'فایل json',
    exportDialogTitle: 'تبدیل مدل ها به فایل json',
    exportButton: 'تبدیل کن',
    exportSetting:{
      removeIdTitle: 'شناسه مدل ها حذف شود'
    },
    searchPlaceHolder: 'واژه مورد نظر ...',
    actionCaption: 'عملیات ها',
    emptyList: 'هیچ ردیفی وجود ندازد',
    limitationNotSet: 'خصوصیت محدوده تنظیم نشده است.',
    confirmSetting: 'تایید',
    rejectSetting: 'انصراف',
    settingTitle: 'تنضیمات',
    limitationTitle: 'محدوده',
    confirmLimitation: 'محدود کن',
    rejectLimitation: 'انصراف',
    methodSuccessTitle: 'عملیات با موفقیت انجام شد.',
    pagination: {
      nextText: 'بعدی',
      prevText: 'قبلی'
    }
  },

  validation: {
    completeFormMessage: 'لطفا اطلاعات را کامل وارد کنید.'
  },

  loginPage: {
    usernameValidation: {
      required: 'نام کاربری را وارد کنید'
    },
    passwordValidation: {
      required: 'کلمه عبور را وارد کنید'
    },
    header: 'فرم ورود',
    signUpHeader: 'ثبت نام کنید',
    username: 'نام کاربری',
    password: 'کلمه عبور',
    language: 'زبان را انتخاب کنید',
    login: 'ورود',
    signUp: 'ثبت نام',
  },
  registerPage: {
    register: 'Register',
    phone: 'Phone'
  },

  page: {
    card: {
      viewDetail: 'بیشتر ببینید'
    }
  },

  model: {
    updateButtonText: 'ویرایش',
    deleteButtonText: 'حذف',
    rejectButtonText: 'لغو',
    okButtonText: 'تایید',
    reservationMessageTitle: 'اعلان ویرایش',
    successPersistTitle: 'با موفقیت ثبت شد.',
    deleteDialog: {
      title: 'هشدار حذف',
      warningNote: 'از حذف مطمئن هستید؟',
      confirm: 'بلی',
      cancel: 'خیر',
      successMessage: 'با موفقیت حذف شد.',
      cancelMessage: 'حذف لغو شد.'
    }
  },

  qasedak: {},

  permission: {
    editor: {
      isGrant: 'دسترسی دارد',
      fullAccessText: 'دسترسی کامل',
      savePermissionText: 'ذخیره',
      captionColumnText: 'امانت دار',
      addPermissionDialogTitle: 'مشخصات دسترسی جدید',
      addTrusteeDialogTitle: 'مشخصات امانت دار جدید',
      addPermissionButtonText: 'اضافه کن',
      addTrusteeButtonText: 'اضافه کن',
      cancelButtonText: 'لغو',
      searchPlaceHolder: 'جستجو',
    }
  },

  blog: {
    searchPanelText: 'جستجو',
    categoriesPanelText: 'دسته بندی ها',
    morePostsText: 'مطالب بیشتر ...'
  },
  post: {
    card:{
      readMore: 'بیشتر بخوانید'
    },
    authorByText: 'توسط',
    emptyText: 'این محتوا بدون متن است.',
    list:{
      columns:{
        title: 'عنوان',
        user: 'نویسنده',
        category: 'دسته بندی',
        date: 'تاریخ',
        commentQty: 'نظرها',
      }
    },
    detail: {
      data: {
        title: 'داده های مطلب',
        key: 'کلید محتوا',
        keyPlaceholder: 'کلید محتوا را وارد کنید',
        categoryTitle: 'دسته بندی',
        bgColorTitle: 'رنگ زمینه',
        bgColorPlaceholder: 'زنگ زمینه را انتخاب کنید',
        colorTitle: 'رنگ قلم',
        colorPlaceholder: 'زنگ قلم را انتخاب کنید',
        tagsTitle: 'برچسب ها',
        tagsPlaceholder: 'یک یا چند برچسب را انتخاب کنید',
        thumbnailTitle: 'تصویر کوچک',
        imageTitle: 'تصویر کاور',
        seoTitle: 'عنوان سئو',
        seoTitlePlaceholder: 'عنوان سئو را وارد کنید',
        seoDescriptionTitle: 'توضیحات سئو',
        seoDescriptionPlaceholder: 'توضیحات مربوط به سئو را وارد کنید',
        seoKeywordsTitle: 'واژه های سئو',
        seoKeywordsPlaceholder: 'واژه های سئو را وارد کنید',
      },
      generalTitle: 'اطلاعات عمومی',
      titlePlaceholder: 'عنوان',
      textType: {
        marked: 'مارک شده',
        html: 'Html',
        text: 'متن',
      },
      markedContentPlaceholder: 'محتوای پست را به صورت مارک شده وارد کنید',
      htmlContentPlaceholder: 'محتوای پست را به صورت html وارد کنید',
      textContentPlaceholder: 'متن را وارد کنید',
      summaryTitle: 'خلاصه',
      classificationTitle: 'نوع',
      summaryPlaceholder: 'خلاصه ای برای پست بنویسید',
      commentsTitle: 'نظرها',
    },
    comment: {
      comments: 'نظر ها',
      addCommentTitle: 'لطفا نظر خود را ارسال نمایید',
      sendButtonText: 'ارسال',
      resetButtonText: 'پاک کن',
      addSuccessMessage: 'نظر شما با موفقیت ثبت شد.',
      rules: {
        name: {
          text: 'نام',
          requiredMessage: 'حتما نام خود را وارد کنید.',
          min_maxMessage: ''
        },
        phone: {
          text: 'تلفن',
          requiredMessage: 'برای دریافت پاسخ شماره همراه خود را وارد کنید.'
        },
        email: {
          text: 'ایمیل',
          requiredMessage: 'لطفا نشانی پست الکترونیکی خود را وارد کنید.'
        },
        note: {
          text: 'شرح',
          requiredMessage: 'نظر خود را بنویسید.'
        }
      }
    }
  },

  menuEditor: {
    emptyTree: 'خالی',
    deleteButtonCaption: '',
    update: '',
    createNew: '',
  },

  actions: {
    cancel: 'لغو',
    next: 'بعدی',
    ok: 'تایید'
  },

  warning: {
    notFound: 'پیدا نشد.',
    formStructureNotFound: 'ساختار فرم پیدا نشد.'
  }
};
